// extracted by mini-css-extract-plugin
module.exports = {"page":"NotFound_page__3U_dG","notFound":"NotFound_notFound__2lNqC","notText":"NotFound_notText__3RC31"};